/* Four visible selectors resolve to one Shopify variant with a server-held total.
   No component price is sent as a cart item or calculated for checkout here. */
(() => {
  function init(scope = document) {
    scope.querySelectorAll('[data-nvx-room]').forEach(root => {
      if (root.dataset.roomReady) return;
      const data = root.querySelector('[data-room-variants]');
      const controls = root.querySelector('[data-room-controls]');
      const fields = ['console', 'tv', 'table', 'chairs'].map(k => root.querySelector(`[data-room-${k}]`));
      const input = root.querySelector('[data-nvx-variant-id]');
      const form = input?.form;
      const button = root.querySelector('[data-nvx-add]');
      if (!data || !controls || fields.some(x => !x) || !form || !button) return;
      let variants;
      try { variants = JSON.parse(data.textContent); } catch { return; }
      const price = root.querySelector('[data-nvx-price]');
      const compare = root.querySelector('[data-nvx-compare]');
      const stock = root.querySelector('[data-nvx-stock]');
      const error = root.querySelector('[data-room-error]');
      const text = button.querySelector('span');
      const tr = document.documentElement.lang.toLowerCase().startsWith('tr');
      const decode = v => {
        if (!v) return false;
        const match = /^Console (200|240) cm \+ TV (160|200|240) cm$/.exec(v.options[0]);
        if (!match) return false;
        const values = [match[1], match[2], v.options[1], v.options[2]];
        if (values.some((value, i) => !Array.from(fields[i].options).some(o => o.value === value))) return false;
        fields.forEach((field, i) => { field.value = values[i]; });
        return true;
      };
      const resolve = () => variants.find(v =>
        v.options[0] === `Console ${fields[0].value} cm + TV ${fields[1].value} cm` &&
        v.options[1] === fields[2].value && v.options[2] === fields[3].value);
      const update = (changeURL = false) => {
        const v = resolve();
        input.value = v ? String(v.id) : '';
        button.disabled = !v?.available;
        error.hidden = Boolean(v);
        price.textContent = v?.price || '—';
        compare.hidden = !v?.onSale;
        compare.textContent = v?.onSale ? v.compare : '';
        stock.textContent = v?.available ? (tr ? 'Sipariş verilebilir' : 'Available to order') : (tr ? 'Mevcut değil' : 'Unavailable');
        stock.classList.toggle('is-out', !v?.available);
        text.textContent = v?.available ? (tr ? 'Sepete ekle' : 'Add to cart') : (tr ? 'Mevcut değil' : 'Unavailable');
        const sku = root.querySelector('[data-room-sku]');
        if (sku) sku.textContent = v?.sku || '';
        if (changeURL && v) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url);
        }
        return v;
      };
      decode(variants.find(v => String(v.id) === input.value));
      fields.forEach(field => field.addEventListener('change', () => update(true)));
      form.addEventListener('submit', event => {
        if (!update()?.available) event.preventDefault();
      });
      update();
      controls.hidden = false;
      const mainImage = root.querySelector('[data-room-image]');
      const imageLink = root.querySelector('[data-room-image-link]');
      const thumbs = root.querySelectorAll('[data-room-thumb]');
      thumbs.forEach(thumb => thumb.addEventListener('click', () => {
        if (!mainImage) return;
        mainImage.src = thumb.dataset.src;
        mainImage.alt = thumb.dataset.alt || '';
        if (imageLink) imageLink.href = thumb.dataset.full;
        thumbs.forEach(item => item.setAttribute('aria-pressed', String(item === thumb)));
      }));
      root.dataset.roomReady = 'true';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
